import { pick, isEmpty } from 'lodash';
import { modifiedProperties } from '@/utils';
import api from '../api';
import contentApi from '../../content/editor/api';

export default {
  async GET_MESSAGE({ commit, dispatch, getters }, id) {
    try {
      const message = await api.getMessage(id, getters.liveType);
      dispatch('PUT_MESSAGE_IN_EDITOR', message);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_TABLE_DATA({ commit, dispatch, getters }, filters) {
    try {
      const response = await api.searchMessage(filters, getters.liveType);
      commit('SET_TOTAL_MESSAGES', response.numResults);
      commit('SET_PAGE', response.page);
      commit('SET_MESSAGES', response.results);
    } catch (error) {
      console.error(error);
    }
  },
  async CREATE_MESSAGE({
    commit, dispatch, getters, rootGetters,
  }, message) {
    try {
      await api.createMessage({ ...message, context: rootGetters.context }, getters.liveType);
    } catch (error) {
      console.error(message);
    }
  },
  async UPDATE_MESSAGE({
    commit, dispatch, state, getters, rootGetters,
  }, message) {
    try {
      const modifiedFields = modifiedProperties(state.messageThatIsBeingEdited, state.messageToBeEdited);
      const diff = pick(state.messageThatIsBeingEdited, modifiedFields);
      if (isEmpty(diff)) {
        return;
      }
      const editedMessage = await api.updateMessage(
        message,
        { ...diff, context: rootGetters.context },
        getters.liveType,
      );
      commit('SET_MESSAGE', editedMessage);
    } catch (error) {
      console.error(error);
    }
  },
  async SET_MESSAGE_THAT_IS_BEING_EDITED_VALUE_BY_ATTRIBUTE({ commit, dispatch }, data) {
    commit('SET_MESSAGE_THAT_IS_BEING_EDITED_VALUE_BY_ATTRIBUTE', data);
  },
  async GET_CONTENT({ commit, dispatch, getters }, contentId) {
    try {
      const response = await contentApi.getContent({ id: contentId, type: getters.liveType });
      commit('SET_STANDALONE_CONTENT', response);
    } catch (error) {
      console.error(error);
    }
  },
  async PUBLISH_UNPUBLISH_MESSAGE({ commit, dispatch }, message) {
    try {
      commit('SET_MESSAGE_TO_BE_EDITED', message);
      commit('SET_MESSAGE_THAT_IS_BEING_EDITED', Object.assign({}, message));
      commit('SET_MESSAGE_THAT_IS_BEING_EDITED_VALUE_BY_ATTRIBUTE', ['published', !message.published]);
      await dispatch('UPDATE_MESSAGE', message);
    } catch (error) {
      console.error(error);
    }
  },
  async DELETE_MESSAGE({ getters }, message) {
    try {
      await api.deleteMessage(message, getters.liveType);
    } catch (error) {
      console.error(error);
    }
  },
  PUT_MESSAGE_IN_EDITOR({ commit, dispatch }, message) {
    commit('SET_MESSAGE_TO_BE_EDITED', message);
    commit('SET_MESSAGE_THAT_IS_BEING_EDITED', Object.assign({}, message));
    commit('SET_MODAL_IS_SHOWN', true);
  },
  RESET_EDITOR({ commit, dispatch }) {
    commit('SET_MESSAGE_TO_BE_EDITED', undefined);
    commit('SET_MESSAGE_THAT_IS_BEING_EDITED', undefined);
    commit('SET_MODAL_IS_SHOWN', false);
  },
  SET_FORM({ commit, dispatch }, form) {
    commit('SET_FORM', form);
  },
  SET_LIVE({ commit }, { id, type }) {
    commit('SET_LIVE', { id, type });
  },
};
